(() => {
  var swiperNav = new Swiper(".js-media-gallery-modal-nav", {
    loop: true,
    spaceBetween: 10,
    slidesPerView: 5,
    freeMode: true,
    watchSlidesProgress: true,
  });
  var swiperMain = new Swiper(".js-media-gallery-modal-main", {
    loop: true,
    spaceBetween: 10,
    navigation: {
      nextEl: ".js-gallery-modal-slider--next",
      prevEl: ".js-gallery-modal-slider--prev",
    },
    thumbs: {
      swiper: swiperNav,
    },
  });

  const gridImages = document.querySelectorAll(".js-product-media-gallery__grid-image");
  const modal = document.querySelector(".js-product-media-gallery__modal");

  Array.from(gridImages).forEach((image, index) => {
    image.addEventListener("click", (e) => {
      modal.showModal();
      swiperMain.slideToLoop(index, 200, false);
    });
  });
})();
